import { ClockCircleOutlined, LogoutOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import moment from "moment";
import { DATA_FORMATO } from "../../utils";
import {
  ehUsuarioAtual,
  formatarCpf,
  inicialNome,
  textoOuTraco,
  textoRelativo,
} from "./format";

function colunaAcoes({ user, onEncerrar, encerrando }) {
  return {
    title: "Ações",
    key: "acoes",
    width: 90,
    align: "center",
    render: (_value, item) =>
      ehUsuarioAtual(item, user) ? null : (
        <Popconfirm
          title={`Encerrar a sessão de ${item.nome}?`}
          okText="Encerrar"
          cancelText="Cancelar"
          okButtonProps={{ danger: true }}
          onConfirm={() => onEncerrar([item])}
        >
          <Button
            danger
            size="small"
            icon={<LogoutOutlined />}
            loading={encerrando}
            title={`Encerrar a sessão de ${item.nome}`}
            aria-label={`Encerrar a sessão de ${item.nome}`}
          />
        </Popconfirm>
      ),
  };
}

export function colunasUsuariosOnline({ user, agora, podeEncerrar, onEncerrar, encerrando }) {
  const colunas = [
    {
      title: "Usuário",
      dataIndex: "nome",
      key: "nome",
      render: (_value, item) => {
        const proprio = ehUsuarioAtual(item, user);
        return (
          <div className="usuarios-online-pessoa">
            <span className="usuarios-online-avatar" aria-hidden>
              {inicialNome(item.nome)}
            </span>
            <div className="usuarios-online-pessoa__dados">
              <div className="usuarios-online-pessoa__nome">
                <strong>{item.nome}</strong>
                {proprio ? <span className="usuarios-online-voce">Você</span> : null}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "CPF",
      dataIndex: "cpf",
      key: "cpf",
      width: 150,
      render: (value) => formatarCpf(value),
    },
    {
      title: "Perfil",
      dataIndex: "perfil",
      key: "perfil",
      render: (value) => textoOuTraco(value),
    },
    {
      title: "Login",
      dataIndex: "login",
      key: "login",
      render: (value) => textoOuTraco(value),
    },
    {
      title: "Instituição",
      dataIndex: "instituicao",
      key: "instituicao",
      render: (value) => textoOuTraco(value),
    },
    {
      title: "Status",
      key: "status",
      width: 110,
      align: "center",
      render: () => <span className="usuarios-online-status">Online</span>,
    },
    {
      title: "Último sinal",
      dataIndex: "dataAcesso",
      key: "dataAcesso",
      width: 170,
      sorter: (a, b) => new Date(a.dataAcesso || 0) - new Date(b.dataAcesso || 0),
      render: (value) => (
        <div className="usuarios-online-sinal">
          <span>
            <ClockCircleOutlined /> {textoRelativo(value, agora)}
          </span>
          <small>{value ? moment(value).format(`${DATA_FORMATO} HH:mm:ss`) : "-"}</small>
        </div>
      ),
    },
  ];
  return podeEncerrar ? [...colunas, colunaAcoes({ user, onEncerrar, encerrando })] : colunas;
}
